// extracted by mini-css-extract-plugin
export default {"mainLayout":"Main_mainLayout__S8xZx"};